// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Style imports:
// import './TradesUntil.scss';
// Component imports:
import Table from 'react-bootstrap/Table';
// Service imports:
import { formatDate, formatNumber } from '../../services/utils';
// Action imports:
import { setSelectedTick } from '../../redux-store/actions/dashboardActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';
import { PublicTradeTickData } from '../../types/api/PublicTypes';
import { TickData } from '../../types/api/Types';

interface IOwnProps {
    symbol: string,
    sortedPublicTradeTickData: PublicTradeTickData[],
    effectiveTickOverride?: TickData | null
};
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & IOwnProps;

class TradesUntil extends React.Component<Props> {
    displayRows = () => {
        const { sortedPublicTradeTickData, setSelectedTick, selectedTick, effectiveTickOverride } = this.props;
        const activeTick = effectiveTickOverride !== undefined ? effectiveTickOverride : selectedTick;

        if (activeTick === null) {
            return (
                <tr className='NoClick'>
                    <td className='text-left EmptyTableText' colSpan={3}>Click a Tick to see the Trades leading up to it.</td>
                </tr>
            )
        }

        // Get jsx rows.
        const jsxRows = sortedPublicTradeTickData.map((trade) => (
            <tr
                key={trade.trade_id}
                className={
                    ((trade === activeTick) ? 'newtrade' : undefined) + 
                    (new Date(trade.time_exec_utc) > new Date(activeTick.timestamp || 0) ? ' next' : '') +
                    ((trade.trade_cancel !== 'N') ? ' cancelled' : '')
                }
                onClick={() => setSelectedTick(trade)}
            >
                <td>{formatDate(trade.timestamp, true, true)}</td>
                <td>{trade.trade_buyer}</td>
                <td className='text-center'>{(trade.aggressive_party === 'S') ? '<' : (trade.aggressive_party === 'B') ? '>' : null}</td>
                <td>{trade.trade_seller}</td>
                <td>{formatNumber(trade.price)}</td>
                <td>{formatNumber(trade.volume, 'volume')}</td>
                <td>{formatNumber(trade.value, 'volume')}</td>
            </tr>
        ));

        if (jsxRows.length === 0) {
            return (
                <tr className='NoClick'>
                    <td className='text-left EmptyTableText' colSpan={3}>No Trades</td>
                </tr>
            );
        }

        return jsxRows;
    }

    render () {
        return (
            <div id='TradesUntil'>
                <h5 className='SectionTitle'>Trades Until Selected Tick</h5>
                <Table className='CompressedTable ClickableRows'>
                    <thead>
                        <tr>
                            <th scope='col'>Time</th>
                            <th scope='col' className='text-right th-small'>Buyer</th>
                            <th scope='col' className='text-center th-small'>Aggressor</th>
                            <th scope='col' className='text-right th-small'>Seller</th>
                            <th scope='col' className='text-right'>Price</th>
                            <th scope='col' className='text-right'>Volume</th>
                            <th scope='col'>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.displayRows()}
                    </tbody>
                </Table>
            </div>
        );
    }
}

function mapStateToProps({ dashboardReducer }: RootState) {
    const { selectedTick } = dashboardReducer;
    return {
        selectedTick
    };
}

const connector = connect(mapStateToProps, { setSelectedTick });
export default connector(TradesUntil);
